
export function format(nn, fixed) {
  const n = nn !== undefined ? nn : 2;
  if (!fixed) return function (v) { return ('' + (Math.round(v * Math.pow(10,n)) / Math.pow(10,n))).replace('.', ','); };
  return function (v) { return v.toFixed(n).replace('.', ','); };
}
